import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-top-nav',
  templateUrl: 'topnav.html',
  styles: [`
    .card {
      width: 100% !important;
    }
  `],
})

export class TopNavComponent implements OnInit {

  user;
  isIn = false;
  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('currentUser'));
    //    console.log(this.user);
  }
  detectmob(): boolean {
    if (navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPad/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i)
    ) {
      return true;
    }
    else {
      return false;
    }
  }
  changeTheme(color: string): void {
    let link: any = $('<link>');
    link
      .appendTo('head')
      .attr({ type: 'text/css', rel: 'stylesheet' })
      .attr('href', 'themes/app-' + color + '.css');
  }

  rtl(): void {
    let body: any = $('body');
    body.toggleClass('rtl');
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
  }

  sidebarToggler(): void {
    let sidebar: any = $('#sidebar');
    let mainContainer: any = $('.main-container');
    sidebar.toggleClass('sidebar-left-zero');
    mainContainer.toggleClass('main-container-ml-zero');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/topnav/topnav.ts